/* eslint-disable max-len, vue/max-len */
export default {
  subdomain: 'tf1',
  sso: {
    protocol: 'openIDConnect',
    login: 'https://login.microsoftonline.com/6f1df60f-fc3e-42a1-87d6-e147f4aabf7f/oauth2/v2.0/authorize?client_id=71dc7c1c-1158-4cf4-ae25-bcb88c511895&response_type=code&scope=openid%20email%20profile&redirect_uri=https%3A%2F%2Ftf1.bubbleplan.net',
    response_type: 'code',
  },
  hideManageAccount: true,
};
